import React from 'react';
import { Button } from '../ui/Button';
import { DollarSign, Shield } from 'lucide-react';
import { trackEvent } from '../../hooks/useMetaPixel';
export function PricingSection() {
  const handleCheckoutClick = () => {
    trackEvent('AddToCart', {
      content_name: 'Manual del Contratista Pro',
      content_type: 'product',
      value: 9700,
      currency: 'ARS'
    });
  };
  return <section id="pricing" className="py-20 px-4 bg-cement relative" data-id="element-88">
      <div className="max-w-3xl mx-auto" data-id="element-89">
        <div className="bg-white border-4 border-charcoal shadow-hard rounded-sm overflow-hidden" data-id="element-90">
          {/* Header */}
          <div className="bg-charcoal text-white p-6 md:p-8 text-center relative" data-id="element-91">
            <div className="absolute top-0 left-0 w-full h-2 bg-caution-tape" data-id="element-92"></div>
            <h2 className="font-heading font-bold text-3xl md:text-4xl uppercase mt-4 mb-2" data-id="element-93">
              Protegé tu trabajo hoy mismo
            </h2>
            <p className="font-body text-lg text-stone-300" data-id="element-94">
              Llevate el sistema completo por menos de lo que cuesta un flete
              corto.
            </p>
          </div>

          {/* Body */}
          <div className="p-6 md:p-10" data-id="element-95">
            {/* Mockup + Price side by side on desktop */}
            <div className="flex flex-col md:flex-row items-center gap-8 mb-8" data-id="element-96">
              {/* Mockup */}
              <div className="w-48 md:w-56 shrink-0" data-id="element-97">
                <img src="https://cdn.magicpatterns.com/uploads/4fZGX8YuPCx79XmGxaVdJ6/Mockup.png" alt="El Manual del Contratista Pro" className="w-full h-auto drop-shadow-xl" data-id="element-98" />
              </div>

              {/* Price */}
              <div className="text-center md:text-left flex-1" data-id="element-99">
                <div className="flex justify-center md:justify-start items-center gap-2 mb-2" data-id="element-100">
                  <span className="font-heading font-bold text-2xl text-stone-500 line-through" data-id="element-101">
                    AR$ 25.000
                  </span>
                </div>
                <div className="flex justify-center md:justify-start items-start gap-1 mb-4" data-id="element-102">
                  <span className="font-heading font-bold text-4xl text-charcoal mt-2" data-id="element-103">
                    AR$
                  </span>
                  <span className="font-heading font-bold text-7xl md:text-8xl text-charcoal leading-none" data-id="element-104">
                    9.700
                  </span>
                </div>

                <div className="bg-amber/20 border-2 border-amber border-dashed p-4 rounded-sm inline-block" data-id="element-105">
                  <p className="font-body font-bold text-charcoal flex items-center gap-2" data-id="element-106">
                    <Shield className="h-5 w-5 text-amber-dark" data-id="element-107" />
                    Pago único. Acceso de por vida.
                  </p>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="text-center" data-id="element-108">
              <Button variant="primary" fullWidth={true} pulse={true} className="mb-4 py-5 text-xl md:text-2xl" href="https://argrutinas.com/cart/42992608674001:1" onClick={handleCheckoutClick} data-id="element-109">
                Quiero el Manual y Empezar a Cobrar Bien
              </Button>

              <p className="font-body text-sm text-stone-500 flex items-center justify-center gap-1" data-id="element-110">
                <DollarSign className="h-4 w-4" data-id="element-111" />
                Pagá seguro con Mercado Pago. Recibilo al instante.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}